import KeKoleksiPengguna from "./src/KeKoleksiPengguna";

export default KeKoleksiPengguna